import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { getController } from "../../context/AppContext";
import { useScript } from "../../hooks/Hooks";

const BackgroundTaskWrapper = () => {
  const [searchParams] = useSearchParams();
  var serviceName = searchParams.get("service");
  const [scriptUrl, setScriptUrl] = useState("");
  const [componentProperties, setComponentProperties] = useState({});

  useEffect(() => {
    if (serviceName !== null && serviceName !== undefined) {
      let serviceObj = getController(serviceName);
      serviceObj.loadScripts().then((response) => {
        if (response) {
          setScriptUrl(response);
        }
      });

      setComponentProperties((prev) => {
        return { ...prev, controller: serviceObj };
      });
    }
  }, [serviceName]);

  var scriptToBeLoaded = useScript(scriptUrl);
  useEffect(() => {
    if (scriptUrl && scriptToBeLoaded === "ready" && componentProperties?.controller) {
      componentProperties?.controller?.init(setComponentProperties);
    }
  }, [scriptToBeLoaded, scriptUrl, componentProperties?.controller]);

  return <div>BackgroundTaskWrapper</div>;
};
export default BackgroundTaskWrapper;
